import { Component } from "react"
import PropTypes from "prop-types"
import SmallAppletCard from "shared/components/applet_card/ifttt_next/small_applet_card"
import { connectionShape } from "app/lib/shared_prop_types"
import logIFTTTNextAction from "app/lib/ifttt_next_log_action"
import appletOrConnectionPath from "app/scripts/applet_or_connection_path"

export class SearchAppletCard extends Component {
  handleOnClick = () => {
    logIFTTTNextAction("click", {
      location_type: "search",
      connection_status: this.props.applet.status,
      object_id: this.props.applet.id,
      object_type: "connection",
      position: this.props.position,
      query: this.props.term,
    })
  }

  render() {
    return (
      <li
        className="my-web-applet-card web-applet-card"
        ref={el => {
          this.scrollObserverEl = el
        }}
      >
        <SmallAppletCard
          applet={this.props.applet}
          onAppletClick={this.handleOnClick}
          appletPath={appletOrConnectionPath(this.props.applet)}
        />
      </li>
    )
  }
}

SearchAppletCard.propTypes = {
  applet: connectionShape.isRequired,
  term: PropTypes.string,
  position: PropTypes.number.isRequired,
}

export default SearchAppletCard
